type MainContentSection = {
  component: string;
};
export const getMainContentSectionsOrder = (
  mainContentFromTrafficConfig: MainContentSection[],
): string[] => {
  return mainContentFromTrafficConfig
    ?.map((section) => (section.component ? section.component : null))
    .filter((component) => component !== null);
};
